import api from '../../../App/socket';

export const setCustomerValuation = function (_id, customer_valuation, selling_reason, customer_valuation_by, close_reason) {
    let update = {
        customer_valuation,
        customer_valuation_date: new Date(),
        selling_reason,
        customer_valuation_by,
        close_valuation_reason: '',
    };

    if (close_reason && close_reason !== '') {
        update = {
            close_valuation_reason: close_reason,
            close_valuation_reason_date: new Date(),
        };
    }


    return api.send({
        api: 'db',
        model: 'Lead',
        action: 'Update',
        options: {
            where: { _id },
            update,
        },
    }).then(response => response).catch(error => error);
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/set_customer_valuation_request.js